import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import SkillsHubSearch from "./SkillsHubSearch";
import { Route, Switch } from "react-router";
import SkillsHubHome from "./SkillsHubHome";
import SkillHubCategories from "./SkillHubCategories";
import SearchResults from "./SearchResults";
import AgentHubHome from "./AgentHubHome";
const SkillsHub = () => {
  return (
    <div className="skill-home scrollable">
      <SkillsHubSearch />
      <Switch>
      <Route path="/dashboard/skill-store/agent-hub" render={() => <AgentHubHome />} />

        {/* <Route
          path="/dashboard/skill-store/home"
          render={() => <SkillsHubHome />}
        /> */}
        <Route
          path="/dashboard/skill-store/category/:id"
          render={() => <SkillHubCategories />}
        />
        <Route
          path="/dashboard/skill-store/search/:id"
          render={() => <SearchResults />}
        />
      </Switch>
    </div>
  );
};

export default SkillsHub;
